var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35,6c-1.4-1.3-3.1-2.1-4.9-2.6c-1.8-0.4-3.7-0.4-5.5,0c-1.8,0.4-3.5,1.3-4.8,2.6L15,10.5 c-2.7,2.4-3.7,6.2-2.8,9.6c0.5,1.7,1.4,3.2,2.8,4.5c0.5,0.4,1,0.8,1.5,1.1c0.2,0.1,0.5,0.2,0.7,0.2c0.3,0,0.5-0.1,0.7-0.3l1.6-1.4 c0.6-0.5,0.8-1.2,0.8-2c0-0.3-0.1-0.6-0.4-0.8c-0.3-0.2-0.5-0.4-0.8-0.6c-1-0.9-1.5-2.1-1.5-3.4c0-1.3,0.5-2.4,1.5-3.4l4.7-4.4 c1-0.9,2.3-1.4,3.6-1.4c1.4,0,2.6,0.5,3.6,1.4c1,0.9,1.5,2.1,1.4,3.4c0,1.3-0.5,2.4-1.5,3.3L30,17.4c-0.3,0.3-0.4,0.7-0.3,1.1 c0.4,1.1,0.7,2.3,0.7,3.5c0,0.4,0.3,0.7,0.7,0.9c0.4,0.2,0.8,0.1,1.2-0.2l2.7-2.5c2.7-2.4,3.7-6.2,2.8-9.6C37.2,8.8,36.3,7.3,35,6  M25,15.3c1.4,1.3,2.3,2.8,2.8,4.5c0.5,1.7,0.5,3.4,0,5.1c-0.5,1.7-1.4,3.3-2.8,4.5L20.2,34c-1.3,1.3-3,2.2-4.8,2.6 c-1.8,0.4-3.7,0.4-5.5,0c-1.8-0.4-3.5-1.3-4.8-2.6c-2.7-2.4-3.8-6.2-2.8-9.7c0.5-1.7,1.4-3.2,2.8-4.5l2.7-2.5 C8,17,8.4,16.9,8.9,17.1c0.4,0.2,0.7,0.5,0.7,0.9c0,1.2,0.3,2.4,0.7,3.5c0.1,0.4,0.1,0.7-0.3,1.1l-0.9,0.9c-1,0.9-1.5,2-1.5,3.3 c0,1.3,0.5,2.4,1.4,3.4c1,0.9,2.2,1.4,3.6,1.4s2.6-0.5,3.6-1.4l4.7-4.4c1-0.9,1.5-2,1.5-3.4c0-1.3-0.5-2.4-1.5-3.4 c-0.2-0.2-0.5-0.4-0.8-0.6c-0.3-0.2-0.4-0.5-0.4-0.8c-0.1-0.7,0.2-1.5,0.8-2l1.6-1.4c0.2-0.2,0.4-0.3,0.7-0.3c0.3,0,0.5,0,0.7,0.2 C24,14.5,24.5,14.9,25,15.3"
  })));
}

export default SvgLink;